module.exports = __webpack_public_path__ + "static/media/grade.b50c75c7.png";